import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Box from '../components/box/Box';
import DataTable from '../components/DataTables/datatable';
import API_URLS from '../summaryapi/apiUrls';
import './ProvidersAvailability.scss'; 
const ProvidersAvailability = () => {
    const [availability, setAvailability] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAvailability = async () => {
            try {
                const response = await fetch(API_URLS.getAllAvailability.url);
                if (!response.ok) {
                    throw new Error('Failed to fetch availability data');
                }
                const result = await response.json();
                if (result.success) {
                    setAvailability(result.data); // Assuming result.data contains the availability array
                } else {
                    toast.error('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Error:', error);
                toast.error('An error occurred while fetching availability data.');
            } finally {
                setLoading(false);
            }
        };

        fetchAvailability();
    }, []);

    if (loading) {
        return (
            <Box>
                <h3>Loading Available Data...</h3>
            </Box>
        );
    }

    // Define the columns for your data table
    const columns = [
        { label: 'Provider ID', key: 'provider_id' },
        { label: 'Day of Week', key: 'day_of_week' },
        { label: 'Start Time', key: 'start_time' },
        { label: 'End Time', key: 'end_time' },
        { label: 'Active', key: 'isActive' },
        { label: 'Created At', key: 'created_at' },
    ];

    return (
        <div className="availability-report-container">
            <h3 className="page-heading">Providers Availability Report</h3>
            <DataTable data={availability} columns={columns} />
        </div>
    );
};

export default ProvidersAvailability;
